export default class LoopError extends Error {
  constructor(wrappedError, requestParams) {
    super()
    this.error = wrappedError
    this.requestParams = requestParams
  }
}
